module.exports = __webpack_public_path__ + "static/Abacus HR Mobile AbaClik-3222511b2551abafef159fe3fd8661f9.pdf";